<script>
export default {
    name: "TransferPrint",

    data() {

        return { order: {},
            transferedItems: [],
            transfereddetails: {
                memo: ``,
                isApproved: false,
                userName: this.$root.username,
            },
        };
    },

    

    computed: {

        
    },
mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchSpecificApprovedTransfer(), this.fetchTransferDetails(), ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 200);
        }).catch(() => { this.$root.loading = false; });
    },
    methods: {

        
         fetchSpecificApprovedTransfer() {

            let url = `StockTransfer/GetSpecificStockTransfter`;
                url += `?TransferCode=${this.$route.params.transferCode}`;

            return this.$http.get(url).then(({ data }) => {
                if(data.length) {
                    this.order = {
                        //  department: data[0].department,
                        // fromStoreId: data[0].fromStoreId,
                        // fromStore: data[0].fromStore,
                        // toStoreId: data[0].toStoreId,
                        // toStore: data[0].toStore,
                        date: data[0].date,
                        storeFrom: data[0].storeFrom,
                        storeTo: data[0].storeTo,
                        approvalMemo: data[0].approvalMemo,
                        // supplier: data[0].supplier,
                        // requsitionTypeId: data[0].requisitionTypeID,
                        // requsitionType: data[0].requisitionType,
                        // txnDate: this.$moment(data[0].trxDate).format(`YYYY-MM-DD`),
                        // userName: data[0].userName,
                        // approved: data[0].approved,
                    };
                }
            }).catch(() => {});
        },
         fetchTransferDetails() {
            let url = `StockTransfer/ApprovedStockTranferItems`;
                url += `?TransferCode=${this.$route.params.transferCode}`;
             url += `&UserName=${this.$root.username}`;
            
            return this.$http.get(url).then(({ data }) => {
                this.transferedItems = data;
            }).catch(() => {});
        },
    }
}
</script>
<template>
<div class="w-full flex flex-wrap">
    <tail-address-header></tail-address-header>
     
    <div class="w-full flex flex-wrap bg-gray-300 p-2">
            <div class="flex-1">
                <h5 class="font-medium text-sm">Date: {{ order.date | dateFormat }}</h5>
            </div>
           
            <div class="flex-1">
                <h5 class="font-medium text-sm">Store From: {{ order.storeFrom }}</h5>
            </div> <div class="flex-1">
                <h5 class="font-medium text-sm">Store To: {{ order.storeTo }}</h5>
            </div>
            
        </div>
     <div class="w-full overflow-visible">
          <div class="w-full overflow-auto my-2">
            <table class="table">
                <thead class="bg-blue-500 text-white text-xs">
                    <tr>
                        
                        <th class="p-tiny border">Item</th>
                        <th class="p-tiny border">Qty</th>
                        <th class="p-tiny border">Description</th>
                        <th class="p-tiny border">User</th> 
                    </tr>
                </thead>
                <tbody class="text-xs bg-gray-100">
                    <tr v-for="orderItem in transferedItems" :key="orderItem.requisitionDetailID">
                         <td class="p-tiny">{{ orderItem.itemName }}</td>
                        <td class="p-tiny">{{ orderItem.qty }}</td>
                         <td class="p-tiny">{{ orderItem.description }}</td>
                        <td class="p-tiny">{{ orderItem.userName}}</td>
                        </tr>
                     
                </tbody>
            </table>
        </div>
         
        <div  class="md:w-2/3 w-full p-1">
            <label for="grid-approval-memo" class="label-control">Approval Memo:</label>
              {{order.approvalMemo?order.approvalMemo:'-'}}
        </div>
    </div>
 
</div>
</template>
